import FroalaEditor from 'froala-editor';

import Utilities from '@/utilities/Utilities.js';

(function (FroalaEditor) {
    FroalaEditor.DEFAULTS = Object.assign(FroalaEditor.DEFAULTS, {
        wordCounter: false,
        pastePlain: true,
    });

    FroalaEditor.PLUGINS.myPlugin = function (editor) {
        const instance = editor;
        let wordCount = 0;
        let wordCounter;
        let wordCountNode;

        function _runWordCounter() {
            const content = instance.html.get(true);

            _getWordCount(content);

            _updateCounter();
        }

        function getWordCount() {
            return wordCount;
        }

        function _build() {
            const el = document.createElement('span');

            el.setAttribute('class', 'fr-word-count');

            const data = document.createTextNode('Words: ');

            const count = document.createTextNode(`${wordCount}`);

            el.appendChild(data);

            el.appendChild(count);

            const toolbar = instance.$second_tb[0];

            toolbar.appendChild(el);

            wordCounter = toolbar.lastChild;
        }

        function _getWordCount(content) {
            wordCount = Utilities.wordCount(content);
        }

        function _updateCounter() {
            wordCountNode = document.createTextNode(`${wordCount}`);

            wordCounter.replaceChild(wordCountNode, wordCounter.childNodes[1]);
        }

        function _init() {
            if (instance.opts.wordCounter && instance.$wp) {
                _build();

                instance.events.on('html.set', function () {
                    _runWordCounter();
                });

                instance.events.on('keyup', function () {
                    _runWordCounter();
                });
            }
        }

        return {
            _init,
            getWordCount,
        };
    };
})(FroalaEditor);
